import {GET_USERS, SET_LOADING_GET_USERS, GET_USERS_SUCCESS, GET_USERS_ERROR, 
    GET_USER, SET_LOADING_GET_USER, GET_USER_SUCCESS, GET_USER_ERROR, 
    POST_USER_DATA, POST_USER_DATA_SUCCESS, POST_USER_DATA_ERROR, SET_LOADING_POST_USER_DATA, 
    SET_LOADING_DEACTIVATE_USER, DEACTIVATE_USER, DEACTIVATE_USER_SUCCESS, DEACTIVATE_USER_ERROR,
    SET_LOADING_ACTIVATE_USER, ACTIVATE_USER, ACTIVATE_USER_SUCCESS, ACTIVATE_USER_ERROR} from '../actions/UserActions';

const INITIAL_STATE = {
    loadingGetUsers: false,
    loadingGetUser: false,
    loadingPostUserData: false,
    loadingDeactivateUser: false,
    loadingActivateUser: false
};

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case SET_LOADING_GET_USERS:
            return {...state, loadingGetUsers: true}
        case GET_USERS:
            return {...state}
        case GET_USERS_SUCCESS:
            return {...state, loadingGetUsers: false}
        case GET_USERS_ERROR:
            return {...state, loadingGetUsers: false}

        case SET_LOADING_GET_USER:
            return {...state, loadingGetUser: true}
        case GET_USER:
            return {...state}
        case GET_USER_SUCCESS:
            return {...state, loadingGetUser: false}
        case GET_USER_ERROR:
            return {...state, loadingGetUser: false}
    
        case SET_LOADING_POST_USER_DATA:
            return {...state, loadingPostUserData: true}
        case POST_USER_DATA:
            return {...state}
        case POST_USER_DATA_SUCCESS:
            return {...state, loadingPostUserData: false}
        case POST_USER_DATA_ERROR:
            return {...state, loadingPostUserData: false}

        case SET_LOADING_DEACTIVATE_USER:
            return {...state, loadingDeactivateUser: true}
        case DEACTIVATE_USER:
            return {...state}
        case DEACTIVATE_USER_SUCCESS:
            return {...state, loadingDeactivateUser: false}
        case DEACTIVATE_USER_ERROR:
            return {...state, loadingDeactivateUser: false}
        
        case SET_LOADING_ACTIVATE_USER:
            return {...state, loadingActivateUser: true}
        case ACTIVATE_USER:
            return {...state}
        case ACTIVATE_USER_SUCCESS:
            return {...state, loadingActivateUser: false}
        case ACTIVATE_USER_ERROR:
            return {...state, loadingActivateUser: false}
        default:
            return state;
    }
}
